import { getQueryParam } from "@/lib/urlHelper";

/**
 * ページ番号からAPIリクエスト用の開始位置（start）を計算します。
 * @param page ページ番号（1オリジン）
 * @param limit 1ページあたりの件数
 */
export const calculateStartPos = (page: number, limit: number): number => {
  return (page - 1) * limit + 1;
};

/**
 * 開始位置（start）から現在のページ番号を計算します。
 * @param start 開始位置（1オリジン）
 * @param limit 1ページあたりの件数
 */
export const calculateCurrentPage = (start: number, limit: number): number => {
  return Math.ceil(start / limit);
};

/**
 * URLのクエリパラメータからページを取得します
 */
export const getPageFromQueryParam = (key = "p") => {
  return toPageNumber(getQueryParam(key));
};

/**
 * ページ番号を安全に変換します。0ページは存在しないので空や0は1として扱います。
 * @param value
 */
export const toPageNumber = (value: string | number | undefined | null): number | undefined => {
  if (!value) {
    return 1;
  }
  const num = Number(value);
  return num === 0 || isNaN(num) ? 1 : num;
};
